import payuCardApi from './api';
import * as types from './actionTypes';

export const fetchPayuCards = () => {
  return dispatch => {
    dispatch({ type: types.FETCH_LIST_REQUEST });

    return payuCardApi
      .getCards()
      .then(payload => {
        const raw = payload?.cards || payload?.cardTokens || payload;
        const cards = Array.isArray(raw) ? raw : [];
        return dispatch({ type: types.FETCH_LIST_SUCCESS, payload: cards });
      })
      .catch(({ message }) => {
        return dispatch({ type: types.FETCH_LIST_FAILURE, payload: message });
      });
  };
};

export const fetchPayuCardsIsNeeded = () => {
  return (dispatch, getState) => {
    const {
      payuCard: { isLoading, isLoaded },
      user: { isAuthenticated },
    } = getState();

    if (isAuthenticated && !isLoading && !isLoaded) {
      return dispatch(fetchPayuCards());
    }

    return null;
  };
};

export const setPayuCardSelect = payload => ({ type: types.SET_CARD_SELECT, payload });
export const setPayuToken = token => ({ type: types.SET_PAYU_TOKEN, payload: token });
export const resetPayuCardState = () => ({ type: types.RESET_PAYU_CARD_STATE });
